import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLanding from '../reducers/landing.reducer';

export const selectLandingState = createFeatureSelector<fromLanding.State>(
  fromLanding.landingFeatureKey
);

export const selectProductDetail = createSelector(
  selectLandingState,
  (state: fromLanding.State) => state.productDetail
);

// Selectores para cupones de descuento
export const selectCouponDiscount = createSelector(
  selectLandingState,
  (state: fromLanding.State) => state.couponDiscount
);
export const selectCouponProducts = createSelector(
  selectLandingState,
  (state: fromLanding.State) => state.couponProducts
);
export const selectCouponError = createSelector(
  selectLandingState,
  (state: fromLanding.State) => state.couponError
);
export const selectCouponLoading = createSelector(
  selectLandingState,
  (state: fromLanding.State) => state.couponLoading
);
